import { usageError } from './usage.ts';

/**
 * 서버에 묻기. 고치는 요청에는 일손이 화면 표시(x-ilsoni)를 붙인다(서버 문지기가 다른 사이트의 요청을 막는 데 씀).
 * 실패하면 서버가 준 말(message)을 그대로 화면에 보여 준다.
 */
export interface Fail {
  ok: false;
  status: number;
  code: string;
  message: string;
  [key: string]: unknown;
}

export type Reply<T> = ({ ok: true } & T) | Fail;

export async function api<T = Record<string, unknown>>(method: 'GET' | 'POST', url: string, body?: unknown): Promise<Reply<T>> {
  try {
    const res = await fetch(url, {
      method,
      credentials: 'same-origin',
      headers: method === 'POST' ? { 'content-type': 'application/json', 'x-ilsoni': '1' } : {},
      ...(method === 'POST' ? { body: JSON.stringify(body ?? {}) } : {})
    });
    const json = (await res.json().catch(() => ({}))) as Record<string, unknown>;
    if (res.ok) return { ...(json as T), ok: true };
    // 사용 기록에는 오류 이름만 남긴다(헷갈리는 화면 찾기). 로그인이 필요한 것은 오류가 아니라 빼고 센다.
    if (res.status >= 500 || (res.status >= 400 && res.status !== 401)) usageError(String(json['code'] ?? res.status));
    return {
      ...json,
      ok: false,
      status: res.status,
      code: String(json['code'] ?? 'error'),
      message: String(json['message'] ?? '잠시 문제가 생겼어요. 조금 있다가 다시 눌러 보시겠어요?')
    };
  } catch {
    return { ok: false, status: 0, code: 'network', message: '인터넷 연결을 확인해 주세요.' };
  }
}

export interface Who {
  user_id: string;
  role: '소장님' | '인력사무소 직원';
  display_name: string;
  login_id: string | null;
  has_kakao: boolean;
  has_naver: boolean;
  plan: '무료' | '베이직' | '프리미엄';
  service_status: string;
  plan_next: string | null;
  trial_until: string | null;
  office_name: string | null;
  office_filled: boolean;
}

/** 업무 화면을 쓸 수 있는 이용 상태(서버 gate.ts의 ACTIVE_STATUSES와 같음) */
export const ACTIVE = new Set(['체험 중', '이용 중', '결제 실패', '해지 예약']);

/** 이 컴퓨터가 기억하는 마지막 로그인 방법(최근 로그인 강조용, 서버에는 보내지 않음) */
export function rememberMethod(method: string): void {
  try {
    localStorage.setItem('ilsoni_last_login', method);
  } catch {
    /* 저장이 막힌 브라우저면 기억하지 않는다 */
  }
}

export function lastMethod(): string | null {
  try {
    return localStorage.getItem('ilsoni_last_login');
  } catch {
    return null;
  }
}
